module.exports = __WEBPACK_EXTERNAL_MODULE_36__;


//////////////////
// WEBPACK FOOTER
// external "esri/widgets/Compass"
// module id = 36
// module chunks = 0